import { countries } from 'data';
import { IInternalDocumentData } from 'types';
import { IDocuments } from '../../../types';

export type IDocumentState = IDocuments & {
  internalUploadedSuccessfully: boolean;
  internalFileUploadError: string | null;
};

export enum DocActionTypes {
  NO_BIOMETRICS = '@@student/documents/NO_BIOMETRICS',
  UPDATE_VISA_REFUSAL_META_DATA = '@@student/documents/UPDATE_VISA_REFUSAL_META_DATA',
  UPDATE_VISA_REFUSAL_META_DATA_SUCCESS = '@@student/documents/UPDATE_VISA_REFUSAL_META_DATA_SUCCESS',
  UPDATE_VISA_REFUSAL_META_DATA_FAILURE = '@@student/documents/UPDATE_VISA_REFUSAL_META_DATA_FAILURE',
  TOGGLE_DOC_SUCCESS = '@@student/documents/TOGGLE_DOC_SUCCESS',
  TOGGLE_DOC_FAILURE = '@@student/documents/TOGGLE_DOC_FAILURE',
  APPROVE_DOC = '@@student/documents/APPROVE_DOC',
  REJECT_DOC = '@@student/documents/REJECT_DOC',
  RESCIND_REJECT_DOC = '@@student/documents/RESCIND_REJECT_DOC',
  DELETE_DOC = '@@student/documents/DELETE_DOC',
  CUSTOM_DOCUMENT_REQUEST = '@@student/documents/CUSTOM_DOCUMENT_REQUEST',
  ACKNOWLEDGE_DOC = '@@student/documents/ACKNOWLEDGE_DOC',
  UPDATE_TB_TEST_META = '@@student/documents/UPDATE_TB_TEST_META',
  UPDATE_TB_SUCCESS = '@@student/documents/UPDATE_TB_SUCCESS',
  UPDATE_TB_FAILURE = '@@student/documents/UPDATE_TB_FAILURE',
  SAVE_DOCUMENT = '@@student/documents/SAVE_DOCUMENT',
  SAVE_DOCUMENT_SUCCESS = '@@student/documents/SAVE_DOCUMENT_SUCCESS',
  SAVE_DOCUMENT_FAILURE = '@@student/documents/SAVE_DOCUMENT_FAILURE',
  SAVE_INTERNAL_DOCUMENT = '@@student/documents/SAVE_INTERNAL_DOCUMENT',
  SAVE_INTERNAL_DOCUMENT_SUCCESS = '@@student/documents/SAVE_INTERNAL_DOCUMENT_SUCCESS',
  SAVE_INTERNAL_DOCUMENT_FAILURE = '@@student/documents/SAVE_INTERNAL_DOCUMENT_FAILURE',
  DELETE_DOCUMENT = '@@student/documents/DELETE_DOCUMENT',
  DELETE_DOCUMENT_SUCCESS = '@@student/documents/DELETE_DOCUMENT_SUCCESS',
  DELETE_DOCUMENT_FAILURE = '@@student/documents/DELETE_DOCUMENT_FAILURE',
}

export interface SaveDocumentPayload {
  uni: string;
  applicantId: string;
  offerId: string;
  id: string;
  docType: string;
  docKey: string;
  fileNames: string[];
  s3Keys: string[];
  uploadedBy?: string;
}

export interface SaveDocumentResponse {
  documents: IDocuments;
  docsComplete: number;
  docsRequired: number;
}

export interface SaveInternalDocumentPayload {
  uni: string;
  applicantId: string;
  offerId: string;
  requirementId: string;
  docKey: string;
  fileNames: string[];
  s3Keys: string[];
  newS3Keys?: string[];
  removedS3Keys?: string[];
}

export interface SaveInternalDocumentResponse {
  internalData: IInternalDocumentData;
}

export interface DeleteDocumentPayload {
  uni: string;
  applicantId: string;
  docType: string;
  docKey: string;
  s3Key: string;
  offerId: string;
  requirementId: string;
  sKey: string;
}

export interface DeleteDocumentResponse {
  s3key: string;
  documentDeleted?: boolean;
  documents?: any;
}

export const isTBCountry = (countryName: string): boolean => {
  const country = countries.find(country => country.countryName === countryName);

  return country ? country.tb : false;
};

export const isATASCourseAndCountry = (countryName: string, isATASCourse: boolean): boolean => {
  const country = countries.find(country => country.countryName === countryName);
  return country ? isATASCourse && country.atas : false;
};
